import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Wordmark } from "./Decor";

const LINKS = [
  { href: "#features", label: "Features" },
  { href: "#pro", label: "Free vs Pro" },
  { href: "#download", label: "Download" },
  { href: "#faq", label: "FAQ" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-[#D8D1C5] bg-[#F7F3EA]/95 backdrop-blur">
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8" aria-label="Main">
        <a href="#top" data-testid="nav-logo" className="inline-flex min-h-[44px] items-center" aria-label="AKTUA home"><Wordmark /></a>
        <div className="hidden items-center gap-7 md:flex">
          {LINKS.map((link) => (
            <a key={link.href} href={link.href} data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`} className="inline-flex min-h-[44px] items-center text-sm font-medium text-[#65706A] transition-colors hover:text-[#2F7555]">
              {link.label}
            </a>
          ))}
          <a href="#get-aktua" data-testid="nav-cta-get-aktua" className="inline-flex min-h-[44px] items-center rounded-xl bg-[#3F8F68] px-6 text-sm font-bold text-white transition-colors hover:bg-[#2F7555]">Get updates</a>
        </div>
        <button data-testid="nav-mobile-menu-button" className="grid min-h-[44px] min-w-[44px] place-items-center rounded-xl text-[#202622] md:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Close menu" : "Open menu"} onClick={() => setOpen(!open)}>
          {open ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
        </button>
      </nav>
      {open ? (
        <div id="mobile-menu" className="border-t border-[#D8D1C5] bg-[#F7F3EA] px-5 pb-6 pt-2 md:hidden">
          {LINKS.map((link) => (
            <a key={link.href} href={link.href} data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`} className="flex min-h-[48px] items-center border-b border-[#EEE9DF] text-base font-medium text-[#202622]" onClick={() => setOpen(false)}>{link.label}</a>
          ))}
          <a href="#get-aktua" data-testid="mobile-nav-cta-get-aktua" className="mt-4 flex min-h-[48px] items-center justify-center rounded-xl bg-[#3F8F68] text-base font-bold text-white" onClick={() => setOpen(false)}>Get release updates</a>
        </div>
      ) : null}
    </header>
  );
};
